// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"205":"3b53517f","3390":"3b53517f","6310":"3b53517f","7685":"3b53517f","8250":"3b53517f"}[chunkId] + ".chunk.css";
};